define(['sentry', 'module'], function (Raven, module) {
    var hostname = window.location.hostname;
    if (/\.docker$/.test(hostname) == false) {
        var dns = module.config().dns;
        Raven.config(dns).install();
    }
});